import CaseTypeForm from "@/components/Forms/CaseTypeForm.tsx";
import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

const CaseTypeDetail = (): ReactNode => {
    const { caseTypeUUID } = useParams<{ caseTypeUUID: string }>();

    if (!caseTypeUUID) {
        return <div>No case type ID provided</div>;
    }

    return <CaseTypeForm caseTypeUUID={caseTypeUUID} />;
};

export default CaseTypeDetail;
